import React, { ReactElement } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Button, Upload, message } from 'antd';
import { RcFile } from 'antd/es/upload/interface';
import ctx from 'classnames';

import {CogIcon} from '../CogIcon';
import { cognitoUser } from '../../../features/auth/authSlice';
import { Microservices } from '../../../app/AllowedMicroservices';
import { BASE_URL } from '../../../app/apiMiddleware';

import uploadIcon from '../../../assets/admin/upload.svg';

import styles from './index.module.scss';
import { getTranslations } from '../../../features/translations/translationsUtils';

interface UploadButtonProps {
    loading?: boolean
    image: ReactElement | boolean
}

interface UploadImageProps {
    loading?: boolean,
    onHandleChange: any,
    imageUrl?: string,
}


function beforeUpload(file: RcFile) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
        message.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
        message.error('Image must smaller than 2MB!');
    }
    return isJpgOrPng && isLt2M;
}

export const UploadButton: React.FunctionComponent<UploadButtonProps> = (props) => {
    const { loading = false, image } = props;
    return <div className={styles.uploadButton}>
        <div className={ctx(styles.image, { [styles.loadedImage]: !!image })}>
            {loading ? <LoadingOutlined /> : (image ? image : <img src={uploadIcon} alt="upload icon"  />)}
        </div>
        <div className={styles.secondColumn}>
            <div>
                <Button type='primary'><CogIcon color='white' size={14} className={styles.buttonIcon} icon='Backup' />{getTranslations('UPLOAD_FILE_UPLOAD')}</Button>
            </div>
            <div className={styles.fileTypes}>
                {getTranslations('UPLOAD_DEFAULT_IMAGE_TYPES')}
            </div>
        </div>
    </div>;
};

export const UploadImage: React.FunctionComponent<UploadImageProps> = (props) => {
    const { imageUrl, loading, onHandleChange: onChandleChange } = props;
    return <Upload
        headers={{
            Authorization: cognitoUser?.getSignInUserSession()?.getAccessToken().getJwtToken() || '',
        }}
        method="POST"
        name="file"
        listType="picture-card"
        className={styles.uploadImage}
        showUploadList={false}
        action={`${BASE_URL[Microservices.FILES_SERVICE]}/files/uploadToS3`}
        beforeUpload={beforeUpload}
        onChange={onChandleChange}
    >
        <UploadButton image={imageUrl ? <img src={imageUrl} alt="avatar" style={{ width: '100%' }} /> : false} loading={loading} />
    </Upload>;
};